import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { fixCredit } from '../assets/images';

const RedressementCreditPage: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    t('creditRepair.benefits.analysis'),
    t('creditRepair.benefits.plan'),
    t('creditRepair.benefits.reports'),
    t('creditRepair.benefits.guidance'),
    t('creditRepair.benefits.monitoring'),
    t('creditRepair.benefits.solutions')
  ];

  return (
    <div className="pt-24">
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h1 className="text-4xl font-bold text-primary-950 mb-6">
                {t('creditRepair.title')}
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                {t('creditRepair.description')}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <Check className="text-black flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-3.5 bg-black hover:bg-gray-900 text-white font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  <span>{t('contact.contactUs')}</span>
                  <ArrowRight size={20} className="ml-2" />
                </Link>
                <Link
                  to="/financement/credit-alternatif"
                  className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-black hover:bg-gray-50 text-black font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  {t('services.learnMore')}
                </Link>
              </div>
            </div>
            <div className="relative">
              <img 
                src={fixCredit}
                alt="Credit score illustration"
                className="w-full h-auto"
              />
            </div>
          </div>
          
          <div className="mt-20 bg-white rounded-xl shadow-sm p-8">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl font-bold text-primary-950 mb-4">
                {t('creditRepair.ready')}
              </h2>
              <p className="text-gray-600 mb-8">
                {t('creditRepair.teamSupport')}
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-3.5 bg-black hover:bg-gray-900 text-white font-medium rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
              >
                <span>{t('creditRepair.startNow')}</span>
                <ArrowRight size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RedressementCreditPage;